import * as Yup from 'yup';

const nigeriaPhoneRegex =/[0-9]{11}/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const LoginSchema=Yup.object().shape({
    username: Yup.string()
    .required('Username is required')
    .test(
      'is-email-or-phone',
      'Must be a valid email or Nigerian phone number',
      value => emailRegex.test(value || '') || nigeriaPhoneRegex.test(value || '')
    ),
  password: Yup.string().required('Password is required'),
  
  })